
import React from "react";
import { Trophy } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { athleteTierSchema } from "@/contexts/program-creation/types";

interface SportDetailsSectionProps {
  form: UseFormReturn<z.infer<typeof athleteTierSchema>>;
}

export default function SportDetailsSection({ form }: SportDetailsSectionProps) {
  return (
    <div className="space-y-5 mb-8">
      <div className="flex items-center gap-2 text-white/90 border-b border-white/20 pb-2">
        <Trophy size={18} />
        <h4 className="font-medium">Sport Details</h4>
      </div>
      
      <FormField
        control={form.control}
        name="sport"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              What sport(s) do they play?
            </FormLabel>
            <FormControl>
              <Input 
                placeholder="e.g., Soccer, Basketball, Track & Field" 
                className="bg-white/20 border-white/30 text-white w-full h-12"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="sportLevel"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              Competition level
            </FormLabel>
            <FormControl>
              <Input 
                placeholder="e.g., High school, Collegiate, Amateur, Professional" 
                className="bg-white/20 border-white/30 text-white w-full h-12"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="positionRole"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              If applicable, what position or role (event) in their sport?
            </FormLabel>
            <FormControl>
              <Input 
                placeholder="e.g., Soccer – Goalkeeper or 100m sprinter" 
                className="bg-white/20 border-white/30 text-white w-full h-12"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
